export enum MasterCalendarLegendItemSymbolBlock {
  Root = 'MasterCalendarLegendItemSymbol',
}

export enum MasterCalendarLegendItemSymbolElement {
  Crossing = 'crossing',
}
